import { userApiClient } from '@/setup/api'

export function useStudentDiscountSubmitMutation() {
    return userApiClient.useMutation('post', '/web/student-discounts')
}
